import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: "'Bitter', serif", // Define Bitter como fonte padrão
  },
});

export default theme;